module.exports = __webpack_public_path__ + "logo-elpais-branco--4c96b560.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/namidia/logo-elpais-branco.png
// module id = 196
// module chunks = 0